export const WHATSAPP_NUMBER_RAW = "+41799475930";
export const WHATSAPP_NUMBER_DISPLAY = "+41 79 947 5930";
// Strip "+" for wa.me / t.me links
export const WHATSAPP_LINK = "https://wa.me/41799475930";
export const TELEGRAM_LINK = "https://t.me/+41799475930";
export const CONTACT_EMAIL = "info@leaner.ch";

export const BRAND = {
  name: "Leaner",
  primary: "#003B5C",
  primaryHover: "#002A42",
};
